"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const Axios = require("axios");
const react_redux_toastr_1 = require("react-redux-toastr");
const AuthenticationActions_1 = require("./authentication/AuthenticationActions");
const util_1 = require("util");
const store_1 = require("./store");
const config = require('../../config');
exports.API = {
    BASE_URL: config.SERVER_URL,
    test: {
        UPLOAD: "/test"
    },
    v2: {
        QR_CODE: {
            GET: businessId => {
                return `/v2/qr-code/${businessId}`;
            },
            CREATE: businessId => {
                return `/v2/qr-code/${businessId}`;
            },
            DELETE: (businessId, qrId) => {
                return `/v2/qr-code/${businessId}/${qrId}`;
            },
            CHECK_EXISTS_BY_PROMO: (businessId, promoId) => `/v2/qr-code/${businessId}/exists/${promoId}`
        },
        SURVEY: {
            LIST: '/v2/survey/:businessId',
            GET_BY_ID: (businessId, surveyId) => {
                return `/v2/survey/${businessId}/${surveyId}/getById`;
            },
            CREATE: businessId => {
                return `/v2/survey/${businessId}`;
            },
            UPDATE: (businessId, surveyId) => `/v2/survey/${businessId}/${surveyId}`,
            REACTIVATE: (businessId, surveyId) => `/v2/survey/${businessId}/${surveyId}/reactivate`,
            DELETE: (businessId, surveyId) => {
                return `/v2/survey/${businessId}/${surveyId}`;
            },
            GET_RESULTS_STATISTICS: (businessId, surveyId) => {
                return `/v2/survey/${businessId}/${surveyId}/results/statistics`;
            },
            GET_RESULTS_TABLE: (businessId, surveyId) => {
                return `/v2/survey/${businessId}/${surveyId}/results/table`;
            },
            GET_RESULTS_TABLE_RAW: (businessId, surveyId) => {
                return `/v2/survey/${businessId}/${surveyId}/results/table/raw`;
            },
            PUBLISH: (businessId, surveyId) => {
                return `/v2/survey/${businessId}/${surveyId}/publish`;
            },
            READY_FOR_PREVIEW: (businessId, surveyId) => {
                return `/v2/survey/${businessId}/${surveyId}/preview`;
            },
            DOWNLOAD_CSV: (businessId, surveyId) => {
                return `/v2/survey/${businessId}/${surveyId}/download-csv`;
            },
            DOWNLOAD_RAW_CSV: (businessId, surveyId) => {
                return `/v2/survey/${businessId}/${surveyId}/download-csv/raw`;
            },
            SEND: (businessId, surveyId) => `/v2/survey/${businessId}/${surveyId}/send`
        },
        USERS: {
            LIST: businessId => `/v2/users/${businessId}`,
            DELETE: (businessId, id) => `/v2/users/${businessId}/${id}`,
            CREATE: businessId => `/v2/users/${businessId}`,
            GET: (businessId, id) => `/v2/users/${businessId}/${id}`,
            UPDATE: (businessId, id) => `/v2/users/${businessId}/${id}`
        },
        ORGANIZATION: {
            GET_BY_ACCESS_TOKEN: () => "/v2/organization",
            GET: routePrefix => `/v2/organization/${routePrefix}`,
            UPDATE: () => "/v2/organization",
            SIGN_UP: () => "/v2/organization/sign-up",
            REQUESTS: {
                USER: {
                    INITIATE: routePrefix => `/v2/organization/join-request/${routePrefix}/user`,
                    ACTIVATE: () => "/v2/organization/join-request/activate/user"
                },
                ACTIVATE: () => "/v2/organization/join-request/activate",
                DECLINE: () => "/v2/organization/join-request/decline",
                GET_BY_TOKEN: token => `/v2/organization/join-request/${token}`,
                FINALIZE: () => "/v2/organization/join-request/finalize"
            }
        },
        BUSINESS: {
            GET_API_CREDENTIALS: businessId => {
                return "/v1/business/create-api-credentials/" + businessId;
            }
        }
    },
    v1: {
        LOGIN: "/v1/user/login",
        LOGIN_TEMP_CHECK: "/v1/user/login/temporary/check",
        UPDATE_PASSWORD: "/v1/user/update-password",
        REGISTER: "/v1/user/register",
        FORGOT_PASS: "v1/user/resetPassword/:email",
        LOGOUT_REDIRECT_URL: "/v1/user/log-out/redirect-url",
        TIME_ZONES: "/v1/user/timezones",
        EDIT_USER: "/v1/user/settings",
        CONFIRMATION: "/v1/user/activate/:code",
        MAIN: "/v1/dashboard",
        MAIN_ADMIN: "/v1/dashboard/admin",
        REDEEM_PROMO: code => {
            return "/v1/public/promo/redeem/" + code;
        },
        REDEEM_LOYALTY_PROGRAM: code => {
            return "/v1/public/loyalty-program/redeem/" + code;
        },
        PROMO_INFO: code => {
            return "/v1/public/promo/information/" + code;
        },
        LOYALTY_PROGRAM_INFO: code => {
            return "/v1/public/loyalty-program/information/" + code;
        },
        SOCIAL_MANAGEMENT: (socialId, pageId) => {
            return "/v1/social/management/" + socialId + '/' + pageId;
        },
        USER: {
            SETTINGS: userId => {
                return '/v1/user/settings/' + userId;
            },
            MY_BUSINESSES: "/v1/user/businesses",
            TRENDS: "/v1/trends/events",
            GET_API_CREDENTIALS: userId => {
                return "/v1/user/create-api-credentials/" + userId;
            }
        },
        PROMOS: {
            GET: "/v1/promo/:businessId/",
            LOYALTY_SETTINGS: businessId => {
                return "/v1/promo/loyaltySettings/" + businessId;
            },
            ADD: "/v1/promo/:businessId/",
            EDIT: "/v1/promo/:businessId/:id",
            SHOW: "/v1/promo/:businessId/:id",
            DELETE: "/v1/promo/:businessId/:id",
            SEND: "/v1/promo/send/:businessId/:id",
            SAVE: "/v1/promo/save/:businessId",
            FIND_BY_KEYWORD: "/v1/promo/findByKeyword"
        },
        HEADBUSINESS: {
            GET: "/v1/headBusinesses",
            ADD: "/v1/headBusinesses"
        },
        STATISTICS: {
            SENTIMENT_MODERATOR: "/v1/statistics/sentimentModerator",
            SENTIMENT_BUSINESS: "/v1/statistics/sentimentBusiness",
            AI_AUTO_REPLY_MODERATOR: "/v1/statistics/getReplyTypes"
        },
        BUSINESSES: {
            ALL: "/v1/user/businesses/all",
            LIST: "/v1/business/list",
            NAME: businessId => {
                return "/v1/business/" + businessId + "/name";
            },
            GET: businessId => {
                return "/v1/business/view/" + businessId;
            },
            GET_PUBLIC: businessId => {
                return "/v1/public/business/view/" + businessId;
            },
            REQUEST_TO_BECOME_AMBASSADOR: "/v1/public/business/request-to-become-ambassador",
            SAVE: businessId => {
                return "/v1/business/" + businessId;
            },
            ADD: "/v1/business",
            MESSAGING_INFO: "/v1/business/messagingInfo/:id",
            CHANGE_STATUS: "/v1/business/changeStatus/:businessId",
            SEND_CODE: "/v1/business/sendCode/:businessId",
            ACTIVATE_PHONE: "/v1/business/activatePhone/:businessId",
            CONFIRMATION: "/v1/business/activate/:code",
            GET_TWILIO_NUMBER: "/v1/business/getTwilioAvailableNumber",
            BUY_TWILIO_NUMBER: "/v1/business/buyTwilioNumber",
            CREATE_SOCIAL_MEDIA_PUBLIC_PAGE_QR: "/v1/business/createSocialMediaPublicPageQr",
            CHECK_KEYWORD_USAGE: "/v1/business/check-keyword-usage",
            DASHBOARD: {
                UNREAD_FEEDBACK: "/v1/dashboard/unread/feedback"
            },
            CHECK_KEYWORD: "/v1/business/keywords/check",
            LOAD_KEYWORDS: "/v1/business/keywords/:id/active",
            SMS_TEMPLATE: {
                CREATE: businessId => {
                    return `/v1/business/sms-template/${businessId}`;
                },
                LIST: businessId => {
                    return `/v1/business/sms-template/${businessId}`;
                },
                UPDATE: (businessId, id) => {
                    return `/v1/business/sms-template/edit/${businessId}/${id}`;
                },
                DELETE: (businessId, id) => {
                    return `/v1/business/sms-template/${businessId}/${id}`;
                },
                GET: (businessId, id) => {
                    return `/v1/business/sms-template/${businessId}/${id}`;
                },
                ALL: businessId => {
                    return `/v1/business/sms-template/all/${businessId}`;
                }
            },
            FEEDBACK: {
                LIST: businessId => {
                    return "/v1/business/feedbacks/" + businessId;
                },
                SHOW: (businessId, id) => {
                    return "/v1/business/feedbacks/" + businessId + "/" + id;
                },
                REPLY: (businessId, id) => {
                    return "/v1/business/feedbacks/" + businessId + "/" + id;
                },
                CHANGE_TYPE: id => {
                    return "/v1/business/feedbacks/change/type/" + id;
                },
                CHANGE_TYPE_MANY: "/v1/business/feedbacks/change-many/type",
                GET_ID: (businessId, customerId) => {
                    return `/v1/business/feedbacks/${businessId}/customer/${customerId}`;
                }
            },
            TRENDS: {
                RECENT_VISITS: businessId => {
                    return "/v1/trends/events/" + businessId;
                },
                GENDER: businessId => {
                    return "/v1/trends/genders/" + businessId;
                },
                EMAILS: businessId => {
                    return "/v1/trends/emails/" + businessId;
                },
                AGES: businessId => {
                    return "/v1/trends/ages/" + businessId;
                },
                GET_TIME_TRENDS: "/v1/trends/timeTrends",
                GET_URL_TRACES: businessId => {
                    return "/v1/trends/bulkSmsUrlTraces/" + businessId;
                },
                GET_URL_TRACE_CUSTOMERS: businessId => {
                    return `/v1/trends/bulkSmsUrlTraces/${businessId}`;
                },
                REMOVE_URL_TRACE_CUSTOMER: urlTraceId => {
                    return `/v1/trends/bulkSmsUrlTraces/${urlTraceId}`;
                }
            },
            GROUPS: {
                LIST: businessId => {
                    return `/v1/business/groups/${businessId}`;
                },
                ALL: businessId => {
                    return `/v1/business/groups/all/${businessId}`;
                },
                GET_CUSTOMER_GROUPS: (businessId, customerId) => {
                    return `/v1/business/groups/${businessId}/customer/groups/${customerId}`;
                },
                CREATE: businessId => {
                    return `/v1/business/groups/${businessId}`;
                },
                READ: (businessId, id) => {
                    return `/v1/business/groups/${businessId}/${id}`;
                },
                UPDATE: (businessId, id) => {
                    return `/v1/business/groups/${businessId}/${id}`;
                },
                DELETE: (businessId, id) => {
                    return `/v1/business/groups/${businessId}/${id}`;
                },
                UPLOAD: businessId => {
                    return `/v1/business/groups/upload/${businessId}`;
                }
            },
            LOYALTY_PROGRAM: {
                SAVE: businessId => {
                    return `/v1/business/loyalty-program/save/${businessId}`;
                },
                LIST: businessId => {
                    return `/v1/business/loyalty-program/${businessId}`;
                },
                DELETE: (businessId, id) => {
                    return `/v1/business/loyalty-program/delete/${businessId}/${id}`;
                },
                GET_BY_ID: id => {
                    return `/v1/business/loyalty-program/get-one/${id}`;
                },
                GET_TRANSACTIONS: id => {
                    return `/v1/business/loyalty-program/get-one-transactions/${id}`;
                },
                DOWNLOAD_TRANSACTION_REPORT: "/v1/business/loyalty-program/report"
            }
        },
        REPORTS: {
            GET_ALL: "/v1/report",
            GET_BUSINESS_REPORTS: businessId => {
                return "/v1/report/business/" + businessId;
            },
            GET_REPORT: reportId => {
                return "/v1/report/" + reportId;
            },
            CREATE: "/v1/report",
            DELETE: reportId => {
                return "/v1/report/" + reportId;
            }
        },
        CONTACTUS: {
            SEND: "/v1/public/contactUs"
        },
        ADMIN: {
            BUSINESSES: "/v1/admin/businesses",
            ADD_BUSINESS: "/v1/admin/businesses",
            DELETE_BUSINESS: "/v1/admin/business/:id",
            USERS: "/v1/admin/users",
            DELETE_USER: "/v1/admin/user/:id",
            MODERATORS: "/v1/admin/moderators",
            AMBASSADORS_REQUESTS: "/v1/admin/ambassadors-requests",
            GET_USER: id => {
                return "/v1/admin/users/" + id;
            },
            ENABLE_DISABLE_USER: userId => {
                return "/v1/admin/user/disableEnable/" + userId;
            },
            ACTIVATE_AMBASSADOR: id => {
                return "/v1/admin/user/activate-ambassador/" + id;
            }
        },
        CUSTOMERS: {
            GET: "/v1/business/customers/:businessId",
            SAVE_ZIP_CODE: token => {
                return "/v1/public/customer/zip-code/" + token;
            },
            BULKSMS: {
                UPLOAD: "/v1/business/customers/bulkSms/upload"
            },
            CREATE_MULTIPLE: "/v1/business/customers/multipleCreate",
            SHOW: "/v1/business/customers/:businessId/:id",
            ADD: "/v1/business/customers/:businessId",
            ADDLIST: "/v1/business/customers/sendSmsToAll/:businessId",
            EDIT: "/v1/business/customers/:businessId/:customerId",
            SEND_MESSAGE_HISTORY: (businessId = ":businessId", id = ":id") => {
                return "/v1/business/customers/send-message-history/" + businessId + "/" + id;
            },
            BLOCK_UNBLOCK: (businessId = ":businessId", id = ":id") => {
                return "/v1/business/customers/blockUnblock/" + businessId + "/" + id;
            },
            SYNC_OPTOUT_STATUS: (id = ":id") => {
                return "/v1/business/customers/syncOptOutStatus/" + id;
            },
            DELETE: (businessId = ":businessId", id = ":id") => {
                return "/v1/business/customers/" + businessId + "/" + id;
            },
            GET_BLOCKED_NUMBERS: (businessId = ":businessId") => {
                return "/v1/business/customers/getBlockedNumbers/" + businessId;
            },
            FIND_FOR_GROUP: businessId => {
                return `/v1/business/customers/${businessId}/findFor/group`;
            },
            COUNT: (businessId = ":businessId", endDate = ":endDate") => `/v1/business/customers/count/${businessId}/${endDate}`,
            All_PHONES_COUNT: businessId => {
                return `/v1/business/customers/${businessId}/allPhonesCount`;
            },
            EXPORT: businessId => `/v1/business/customers/export/${businessId}`,
            SEND_HISTORY: "/v1/public/business/customers/send-history"
        },
        BULKSMS: {
            UPLOAD_MULTI_BUSINESSES: "/v1/bulkSms/uploadFileMultiBusiness",
            CANCEL_SCHEDULE: "/v1/bulkSms/:bulkSmsId/cancelSchedule",
            LIST: "/v1/bulkSms/:businessId",
            GET: "/v1/bulkSms/:businessId/:id",
            GET_DETAIL: "/v1/bulkSms/details/:businessId/:id",
            EDIT: "/v1/bulkSms/:businessId/:id",
            DELETE: "/v1/bulkSms/:businessId/:id",
            SAVE_SEND: "/v1/bulkSms/saveAndSend/:businessId",
            EDIT_SEND: "/v1/bulkSms/editAndSend/:businessId/:id",
            SAVE: "/v1/bulkSms/save/:businessId",
            SEND: "/v1/bulkSms/send/:businessId/:id",
            STATS: id => {
                return "/v1/bulkSms/reports/stats/" + id;
            },
            REASONS: id => {
                return "/v1/bulkSms/reports/reasons/" + id;
            }
        },
        FEEDBACK_CODE: code => {
            return "/v1/public/rate/" + code;
        },
        RATE_CODE: code => {
            return "/v1/public/rateStars/" + code;
        },
        FEEDBACK_MESSAGE: feedbackId => {
            return "/v1/public/feedbackMessage/" + feedbackId;
        },
        TEMPLATES: {
            LIST: "/v1/templates/:businessId",
            ADD: "/v1/templates/:businessId",
            DELETE: "/v1/templates/:businessId/:templateId"
        },
        FEEDBACK: {
            SHOW: code => {
                return "/v1/public/feedback/reply/" + code;
            },
            REPLY: code => {
                return "/v1/public/feedback/reply/" + code;
            }
        },
        BLACK_WORD: {
            ADD: "/v1/blackWord",
            LIST: (type = ":type") => {
                return "/v1/blackWord/type/" + type;
            },
            MODERATOR_LIST: "/v1/blackWord/moderator/all/list",
            GET: (id = ":id") => {
                return "/v1/blackWord/" + id;
            },
            EDIT: (id = ":id") => {
                return "/v1/blackWord/" + id;
            },
            DELETE: "/v1/blackWord/delete/words"
        },
        SYSTEM_SETTINGS: {
            LIST: '/v1/system-settings',
            EDIT: '/v1/system-settings'
        },
        CUSTOM_REPORTS: {
            DOWNLOAD: (reportType = ":reportType") => {
                return "/v1/admin/custom-reports/" + reportType;
            }
        },
        TRACE_URL: {
            GET: (code = ":id") => {
                return "/v1/public/define-sms-origin-url/" + code;
            }
        }
    }
};
Axios.defaults.baseURL = exports.API.BASE_URL;
function doUpload(uri, params = {}, onUploadProgress) {
    let requestConfig = createRequest(uri, true);
    requestConfig.method = 'POST';
    requestConfig.data = params;
    requestConfig.onUploadProgress = onUploadProgress;
    return Axios(requestConfig);
}
exports.doUpload = doUpload;
function doPost(uri, params = {}, isPrivate = true) {
    let requestConfig = createRequest(uri, isPrivate);
    requestConfig.method = 'POST';
    requestConfig.data = params;
    return Axios(requestConfig);
}
exports.doPost = doPost;
function doPostWithFormData(uri, params = {}, isPrivate = true) {
    let requestConfig = createRequest(uri, isPrivate);
    requestConfig.method = 'POST';
    requestConfig.headers['Content-Type'] = 'multipart/form-data';
    requestConfig.headers['Accept'] = 'application/json, */*';
    requestConfig.data = params;
    return Axios(requestConfig);
}
exports.doPostWithFormData = doPostWithFormData;
function doPut(uri, params = {}, isPrivate = true) {
    let requestConfig = createRequest(uri, isPrivate);
    requestConfig.method = 'PUT';
    requestConfig.data = params;
    return Axios(requestConfig);
}
exports.doPut = doPut;
function doDelete(uri, params = {}, isPrivate = true) {
    let requestConfig = createRequest(uri, isPrivate);
    requestConfig.method = 'DELETE';
    requestConfig.params = params;
    return Axios(requestConfig);
}
exports.doDelete = doDelete;
function doGet(uri, params = {}, isPrivate = true) {
    let requestConfig = createRequest(uri, isPrivate);
    requestConfig.method = 'GET';
    requestConfig.params = params;
    return Axios(requestConfig);
}
exports.doGet = doGet;
function doDownload(uri, fileName, params = {}, isPrivate = true) {
    let requestConfig = createRequest(uri, isPrivate);
    requestConfig.method = 'GET';
    requestConfig.params = params;
    requestConfig.responseType = 'blob';
    return Axios(requestConfig).then(response => {
        const href = window.URL.createObjectURL(response.data);
        const anchorElement = document.createElement('a');
        anchorElement.href = href;
        anchorElement.download = fileName;
        document.body.appendChild(anchorElement);
        anchorElement.click();
        document.body.removeChild(anchorElement);
        window.URL.revokeObjectURL(href);
    }).catch(error => {
        console.log('error: ', error);
    });
}
exports.doDownload = doDownload;
exports.dispatchError = (error, func) => {
    try {
        if (!util_1.isNullOrUndefined(error.response)) {
            const statusCode = parseInt(error.response.status);
            if (statusCode === 401) {
                store_1.default.dispatch(AuthenticationActions_1.logoutUser());
            } else {
                func();
            }
        } else {
            func();
        }
    } catch (_error) {
        exports.handleError(error);
    }
};
exports.handleError = error => {
    if (util_1.isNullOrUndefined(error.response)) {
        console.error(error);
        const message = error.message || "Something wrong, please try later.";
        react_redux_toastr_1.toastr.error("Error", message, { timeOut: null });
    } else {
        const statusCode = parseInt(error.response.status);
        if (statusCode === 401) {
            store_1.default.dispatch(AuthenticationActions_1.logoutUser());
        } else if (statusCode === 400) {
            let errorObject = {};
            let errors = [];
            if (Array.isArray(error.response.data)) {
                errors = error.response.data;
            } else {
                errors.push(error.response.data);
            }
            errors.forEach(err => {
                if (util_1.isNullOrUndefined(err.param)) {
                    react_redux_toastr_1.toastr.error("Error", err.reason || err.errorMessage);
                } else {
                    errorObject = addErrorItem(errorObject, err.reason, err.param);
                }
            });
            return errorObject;
        } else {
            react_redux_toastr_1.toastr.error("Error", "Something wrong, please try later.");
        }
    }
    return {};
};
exports.dataTableBeforeSend = request => {
    const state = store_1.default.getState();
    request.setRequestHeader("Authorization", "Bearer " + state.authentication.accessToken);
    request.setRequestHeader("Content-Type", "application/json");
};
const addErrorItem = (errors, errorReason, errorParam) => {
    if (util_1.isNullOrUndefined(errors[errorParam])) {
        errors[errorParam] = errorReason;
    } else {
        let existErrors = errors[errorParam];
        if (existErrors instanceof Array) {
            existErrors.push(errorReason);
        } else {
            existErrors = [existErrors, errorReason];
        }
        errors[errorParam] = existErrors;
    }
    return errors;
};
const createRequest = (uri, isPrivate = true) => {
    let requestConfig = {
        url: uri,
        headers: {
            'Content-Type': 'application/json',
            'pragma': 'no-cache'
        },
        responseType: 'json'
    };
    if (isPrivate) {
        if (store_1.default) {
            const state = store_1.default.getState();
            // const authorizationStore = loadState() || INITIAL_STATE.authentication;
            requestConfig.headers['Authorization'] = "Bearer " + state.authentication.accessToken;
        } else {
            requestConfig.headers['Authorization'] = "Bearer " + JSON.parse(localStorage.getItem('state')).accessToken;
        }
    }
    return requestConfig;
};


//////////////////
// WEBPACK FOOTER
// ./client/src/api.ts
// module id = 609
// module chunks = 0 1 2